import React from 'react';
import type INavData from '../../../interfaces/config/nav';
import Icon from '~/components/icon';
import Link from '~/components/link';
import ScrollableRow from '../../scrollable-row';
import styles from '../style/featured-menu.module.css';

interface IProps {
  navData: INavData;
}

const FeaturedMenu: React.FC<IProps> = ({ navData }) => {
  const featuredMenuItems = navData.featuredMenu;

  const getIcon = (iconString: string) => {
    if (!iconString) return null;

    const [icon, dimension = '32'] = iconString.split(',');

    return (
      <div className={styles.featuredIcon}>
				<Icon
          icon={icon}
          height={parseInt(dimension, 10)}
          width={parseInt(dimension, 10)} />

			</div>);

  };

  const featuredItems = [].concat(...Object.values(featuredMenuItems));

  return (
    <ScrollableRow className={styles.featuredMenu}>
			{featuredItems.map((item) =>
      <Link key={item.url} to={item.url} className={styles.featuredItem}>
					{getIcon(item.icon)}
					{item.text}
				</Link>
      )}
		</ScrollableRow>);

};

export default FeaturedMenu;